import React, { Component } from "react";
import DescriptionCode from "../../subcompo/DescriptionCode";
import { NumericFormat } from "react-number-format";
import { Form } from "react-bootstrap";

const axios = require("axios");
class Newcode extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate() {
    if (
      JSON.stringify(this.props.classCodesInfo) !==
      JSON.stringify(this.state.classCodesInfo)
    ) {
      this.setState({ classCodesInfo: this.props.classCodesInfo });
    }
  }

  componentDidMount() {
    const {
      classCodesInfo,
      addressBlockNo,
      addressChildNo,
      handleMinMax,
    } = this.props;
    let currProspect = JSON.parse(sessionStorage.getItem("currProspect"));
    for (let index in classCodesInfo) {
      if (currProspect && classCodesInfo[index].classCodeDescription) {
        let childrenLoc = currProspect.childrenLoc;
        if (
          Object.keys(classCodesInfo[index].classCodeDescription).length === 0
        ) {
          classCodesInfo[index].classCodeDescription =
            childrenLoc[addressBlockNo].classCodesInfo[
              index
            ].classCodeDescription;
        }
      }
    }
    // handleMinMax(addressBlockNo, addressChildNo);
    this.setState({ classCodesInfo: classCodesInfo });
  }
  // conditional_Render_FT_PT = (value) => {
  //   let style = {};
  //   if (window.screen.width < 993) {
  //     style = {
  //       maxWidth: "100%",
  //       paddingInline: "15px",
  //     };

  //     return style;
  //   }
  //   if (value === "FT" && window.screen.width > 993) {
  //     style = {
  //       width: "13%",
  //       paddingInline: "15px",
  //     };
  //     return style;
  //   }
  //   if (value === "PT" && window.screen.width > 993) {
  //     style = {
  //       width: "14%",
  //       paddingInline: "15px",
  //     };
  //     return style;
  //   }
  //   if (value === "annual" && window.screen.width > 993) {
  //     style = {
  //       width: "18%",
  //       paddingInline: "15px",
  //     };
  //     return style;
  //   }
  //   if (value === "WC" && window.screen.width > 993) {
  //     style = {
  //       width: "16%",
  //       paddingInline: "15px",
  //     };
  //     return style;
  //   }
  // };
  conditional_Render_FT_PT = (value) => {
    // Always full width on mobile
    if (window.innerWidth < 992) {
      return { width: "100%", paddingInline: "15px" };
    }
    switch (value) {
      case "WC":
        return { width: "40%", paddingInline: "15px" };
      case "FT":
        return { width: "13%", paddingInline: "15px" };
      case "PT":
        return { width: "13%", paddingInline: "15px" };
      case "AP":
        return { width: "15%", paddingInline: "15px" };
      default:
        return {};
    }
  };

  render() {
    const {
      addressChildNo,
      addressBlockNo,
      state,
      removeClassCode,
      updateClassCodesInfo,
      handleMinMax,
      updateLocationError,
    } = this.props;

    const { classCodesInfo } = this.state;

    let codeCount = 1;
    try {
      codeCount = Object.keys(classCodesInfo).length;
    } catch (e) { }

    return (
      <div className="calcPremium grey Workerscomp_margin  ">
        <div className="row align-items-center px-2" id="worker_comp_fields">
          <p className="col-12 col-md-6 col-sm-12 col-lg-1 d-flex align-items-center"></p>

          {/* Description / Class Code */}
          <div style={this.conditional_Render_FT_PT("WC")} className="col-12 col-md-6 col-sm-12 col-lg-4">
            <DescriptionCode
              addressBlockNo={addressBlockNo}
              addressChildNo={addressChildNo}
              state={(state || "").toLowerCase()}
              handleMinMax={handleMinMax}
              classCodesInfo={classCodesInfo}
              updateLocationError={updateLocationError}
              updateClassCodesInfo={updateClassCodesInfo}
            />
            <span
              id={`invalidCode${addressBlockNo}${addressChildNo}`}
              style={{ color: "red" }}
            ></span>
          </div>

          {/* # Full-Time */}
          <div style={this.conditional_Render_FT_PT("FT")} className="col-12 col-md-6 col-sm-12 col-lg-1">
            <Form.Group className="form-group w-100">
              <label
                htmlFor={`classCodes${addressBlockNo}${addressChildNo}1`}
                title="Number of full time employees"
                className="mandatory"
              >
                <b className="font-family-montserrat-semi-bold"># Full-Time</b>
              </label>
              <NumericFormat
                id={`classCodes${addressBlockNo}${addressChildNo}1`}
                title="Number of full time employees"
                isNumericString
                value={classCodesInfo?.[addressChildNo]?.ft?.value || ""}
                onKeyUp={(e) =>
                  updateClassCodesInfo(
                    addressBlockNo,
                    addressChildNo,
                    "ft",
                    e.currentTarget.value.trim()
                  )
                }
                onBlur={() => handleMinMax(addressBlockNo, addressChildNo)}
                className="text-center w-100"
                placeholder="# FT"
                style={{
                  outline: "none",
                  borderColor: classCodesInfo?.[addressChildNo]?.ft?.error
                    ? "red"
                    : "",
                }}
                format="#####"
                autoComplete="off"
              />
            </Form.Group>
          </div>

          {/* # Part-Time */}
          <div style={this.conditional_Render_FT_PT("PT")} className="col-12 col-md-6 col-sm-12 col-lg-1">
            <Form.Group className="form-group w-100">
              <label
                htmlFor={`classCodes${addressBlockNo}${addressChildNo}2`}
                title="Number of part time employees"
                className="mandatory"
              >
                <b className="font-family-montserrat-semi-bold"># Part-Time</b>
              </label>
              <NumericFormat
                id={`classCodes${addressBlockNo}${addressChildNo}2`}
                title="Number of part time employees"
                isNumericString
                value={classCodesInfo?.[addressChildNo]?.pt?.value || ""}
                onKeyUp={(e) =>
                  updateClassCodesInfo(
                    addressBlockNo,
                    addressChildNo,
                    "pt",
                    e.currentTarget.value.trim()
                  )
                }
                onBlur={() => handleMinMax(addressBlockNo, addressChildNo)}
                className="text-center w-100"
                placeholder="# PT"
                style={{
                  outline: "none",
                  borderColor: classCodesInfo?.[addressChildNo]?.pt?.error
                    ? "red"
                    : "",
                }}
                format="#####"
                autoComplete="off"
              />
            </Form.Group>
          </div>

          {/* Annual Payroll */}
          <div style={this.conditional_Render_FT_PT("AP")} className="col-12 col-md-6 col-sm-12 col-lg-2">
            <Form.Group className="form-group w-100">
              <label
                htmlFor={`classCodes${addressBlockNo}${addressChildNo}3`}
                title="Annual Payroll"
                className="mandatory"
              >
                <b className="font-family-montserrat-semi-bold">Annual Payroll</b>
              </label>
              <NumericFormat
                id={`classCodes${addressBlockNo}${addressChildNo}3`}
                title="Annual Payroll"
                value={classCodesInfo?.[addressChildNo]?.payroll?.value || ""}
                onKeyUp={(e) =>
                  updateClassCodesInfo(
                    addressBlockNo,
                    addressChildNo,
                    "payroll",
                    e.currentTarget.value
                  )
                }
                onBlur={() => handleMinMax(addressBlockNo, addressChildNo)}
                className="text-center w-100"
                placeholder="Annual Payroll"
                thousandSeparator
                prefix="$"
                type="text"
                autoComplete="off"
                style={{
                  outline: "none",
                  borderColor: classCodesInfo?.[addressChildNo]?.payroll?.error
                    ? "red"
                    : "",
                }}
                onKeyDown={(e) => {
                  if (e.key === "-" || e.key === "−") e.preventDefault();
                }}
              />
            </Form.Group>
          </div>

          {/* Delete Button */}
          <div className="col-12 col-md-0 col-lg-1 d-flex align-items-center justify-content-center">
            {codeCount > 1 && (
              <button
                type="button"
                className="rmvLoc btnInvisible transpButton"
                onClick={() => removeClassCode(addressBlockNo, addressChildNo)}
              >
                <img
                  src={require("../../../images/delete4.png")}
                  alt="Delete"
                  className="delete_records_btn"
                />
              </button>
            )}
          </div>
        </div>

        {/* <div
          className="text-left grey"
          style={{ width: "16%", paddingInline: "15px" }}
        >
          <Form.Group className="form-group">
            <label
              for={"pricing" + addressBlockNo + addressChildNo + "4"}
              title="Requested W/C Pricing %"
              style={{ display: "flex", marginTop: "-1.5rem" }}
            >
              <b className="font-family-montserrat-semi-bold">
                Requested W/C Pricing %
              </b>
            </label>
            <NumericFormat
              title="Requested W/C Pricing %"
              id={"pricing" + addressBlockNo + addressChildNo + "3"}
              onKeyUp={(event) => {
                updateClassCodesInfo(
                  addressBlockNo,
                  addressChildNo,
                  "pricing",
                  event.target.value
                );
              }}
              fixedDecimalScale = {true}
              decimalScale = {2}
              style={{
                borderColor:
                  classCodesInfo &&
                  classCodesInfo[addressChildNo] &&
                  classCodesInfo[addressChildNo].pricing &&
                  classCodesInfo[addressChildNo].pricing.error
                    ? "red"
                    : "",
                backgroundColor:
                  classCodesInfo &&
                  classCodesInfo[addressChildNo] &&
                  classCodesInfo[addressChildNo].pricing &&
                  classCodesInfo[addressChildNo].pricing.disabled
                    ? "#c2c4c5"
                    : "",
              }}
              value={
                classCodesInfo && classCodesInfo[addressChildNo].pricing
                  ? classCodesInfo[addressChildNo].pricing.value
                  : ""
              }
              disabled={
                classCodesInfo &&
                classCodesInfo[addressChildNo] &&
                classCodesInfo[addressChildNo].pricing &&
                classCodesInfo[addressChildNo].pricing.disabled
              }
              suffix="%"
              name="pricing"
              placeholder="W/C Pricing%"
              onBlur={() => handleMinMax(addressBlockNo, addressChildNo)}
              className="text-center"
              type="text"
              autoComplete="off"
            />
          </Form.Group>
        </div> */}

        {/* <br /> */}

        {/* {
          <div className="col-sm-4 relDiv rangeSlider">
            <div className="row justify-content-center">
              <div id="minVal" className="premVal">
                <span className="minValueCC">{min}</span>
              </div>
              <div className="barBG"></div>
              <div id="maxVal" className="premVal">
                <span className="manValueCC">{max}</span>
              </div>
            </div>
          </div>
        } */}
      </div>
    );
  }
}
export default Newcode;
